"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowUturnLeftIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ArrowUturnLeftIcon = (props) => {
    return ((0, jsx_runtime_1.jsx)("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", className: "w-6 h-6", ...props, children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", d: "M9.53 2.47a.75.75 0 0 1 0 1.06L4.81 8.25H15a6.75 6.75 0 0 1 0 13.5h-3a.75.75 0 0 1 0-1.5h3a5.25 5.25 0 1 0 0-10.5H4.81l4.72 4.72a.75.75 0 1 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 0Z", clipRule: "evenodd" }) }));
};
exports.ArrowUturnLeftIcon = ArrowUturnLeftIcon;
